import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  funded: [],
  investor: [],
  loaded: {
    funded: false,
    investor: false
  },
  loading: {
    funded: false,
    investor: false
  },
  error: {
    funded: null,
    investor: null
  }
};

export const weeklyReportDatesSlice = createSlice({
  name: 'weeklyReportDates',
  initialState,
  reducers: {
    setWeeklyReportDates: (state, action) => {
      const { dataset, dates } = action.payload || {};
      if (!dataset || !Object.prototype.hasOwnProperty.call(state, dataset)) {
        return;
      }
      state[dataset] = dates || [];
      state.loaded[dataset] = true;
      state.error[dataset] = null;
    },
    setWeeklyReportDatesLoading: (state, action) => {
      const { dataset, loading } = action.payload || {};
      if (!dataset || !Object.prototype.hasOwnProperty.call(state.loading, dataset)) {
        return;
      }
      state.loading[dataset] = Boolean(loading);
    },
    setWeeklyReportDatesError: (state, action) => {
      const { dataset, error } = action.payload || {};
      if (!dataset || !Object.prototype.hasOwnProperty.call(state.error, dataset)) {
        return;
      }
      state.error[dataset] = error || null;
    },
    clearWeeklyReportDates: (state, action) => {
      const { dataset } = action.payload || {};
      if (!dataset || !Object.prototype.hasOwnProperty.call(state, dataset)) {
        return;
      }
      state[dataset] = [];
      state.loaded[dataset] = false;
      state.loading[dataset] = false;
      state.error[dataset] = null;
    }
  }
});

export const {
  setWeeklyReportDates,
  setWeeklyReportDatesLoading,
  setWeeklyReportDatesError,
  clearWeeklyReportDates
} = weeklyReportDatesSlice.actions;

export default weeklyReportDatesSlice.reducer;
